<div class="main-container">
  <h2 class="main-container-header">
    Are you sure you want to remove {{ data.person.fullName }} from this
    Workspace?
  </h2>
  <div class="main-container-text">
    <p>Removing this person from a Workspace will:</p>
    <ul>
      <li>Remove them from all teams in this Workspace.</li>
      <li>Delete all values in tracked fields on teams in this Workspace.</li>
      <li>
        Remove any responses they have for Lineup Forms, Team Forms, and Team
        Surveys. Any evaluations that they submitted for other people will be
        preserved.
      </li>
    </ul>
    <p>
      <b>This action is permanent and cannot be undone.</b>
      If you are sure, please type "REMOVE" in the field below.
    </p>
    <mat-form-field appearance="outline" class="value-description">
      <mat-label>Type REMOVE to confirm</mat-label>
      <input
        data-testid="confirm-delete"
        matInput
        type="text"
        [(ngModel)]="textMatcherValue"
      />
    </mat-form-field>
  </div>
  <div class="button-container" mat-dialog-actions>
    <button
      mat-button
      class="delete-color"
      [mat-dialog-close]="removeButtonClicked()"
      id="person-delete-modal-button"
      [disabled]="isRemoveButtonDisabled()"
    >
      Remove Person From Workspace
    </button>
    <button type="button" mat-button [mat-dialog-close]="cancelButtonClicked()">
      Cancel
    </button>
  </div>
</div>
